import { BottomSheet, useModalState } from "@src/appV2/redesign/system/ui-components";

import { IntroSheet } from "../IntroSheet/IntroSheet";

export function IntroModal() {
  const modalState = useModalState("open");

  const handleContinue = () => {
    modalState.closeModal();
  };

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet modalState={modalState} onClose={handleClose}>
      <IntroSheet onContinue={handleContinue} />
    </BottomSheet>
  );
}
